import { StyleSheet, Dimensions } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
    position: 'relative',
    backgroundColor: Colors.white,
  },
  headerBackground: (top = 0) => {
    return {
      width: width,
      height: width / 2.9,
      paddingTop: top,
      backgroundColor: '#ED1B24',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
    }
  },
  container: {
    flex: 1,
  },
  headerOfferTitle: {
    marginHorizontal: 16,
  },
  headerContentContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginVertical: 8,
  },
  fillRemainingSpace: {
    flexGrow: 1,
  },

  headerWrapper: {
    height: 79,
    overflow: 'visible',
  },
  header: {
    height: 94,
    paddingBottom: 28,
    paddingHorizontal: 16,
    justifyContent: 'flex-end',
  },
  empty: {
    width: 24,
    height: 24,
  },
  headerContentWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  inCoverContent: {
    justifyContent: 'space-between',
    paddingTop: 24,
  },
  closeIcon: {
    tintColor: Colors.white,
  },
  backIcon: {
    margin: 16,
    tintColor: Colors.white,
  },
  scrollContainer: {
    borderRadius: 12,
    backgroundColor: Colors.white,
  },
  scrollContentContainer: (bottom = 0) => {
    return {
      paddingBottom: bottom + 24,
    }
  },
  buttonContainer: {
    backgroundColor: 'transparent',
    paddingHorizontal: 16,
    paddingTop: 32,
  },
  button: {
    marginTop: 16,
  },

  // Modal
  modal: {
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    backgroundColor: Colors.blackRGBA(0.2),
  },
  permissionContainer: {
    backgroundColor: Colors.white,
    width: width - 32,
    padding: 16,
    borderRadius: 6,
  },
  permissionButton: {
    alignSelf: 'flex-end',
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginTop: 32,
    borderRadius: 6,
  },
})

const itemStyles = StyleSheet.create({
  wrapper: {
    marginTop: 32,
    marginBottom: 8,
  },
  sectinTitle: {
    marginBottom: 21,
    marginHorizontal: 16,
  },
  cardContainer: {
    backgroundColor: Colors.white,
    marginHorizontal: 16,
    elevation: 8,
    shadowColor: Colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    borderRadius: 6,
  },
  card: {
    backgroundColor: Colors.white,
    position: 'relative',
    borderRadius: 6,
    overflow: 'hidden',
  },
  cover: {
    height: 152,
    flexDirection: 'row',
  },
  details: {
    backgroundColor: Colors.white,
    paddingHorizontal: 16,
    paddingTop: 16,
    alignItems: 'flex-start',
  },
  cta: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 16,
    paddingRight: 16,
  },
  ctaIcon: {
    tintColor: Colors.vfRed,
  },
  listContainer: {
    maxHeight: 52,
    position: 'absolute',
    marginVertical: 16,
  },
  listContent: {
    paddingRight: 16,
    paddingLeft: 8,
  },
  inCoverInfo: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    height: 20,
    paddingHorizontal: 12,
    marginLeft: 8,
    overflow: 'hidden',
  },

  // My Plan
  touchable: {
    flexDirection: 'row',
    paddingVertical: 16,
    alignItems: 'center',
  },
  leftIcon: {
    margin: 16,
    flexShrink: 0,
  },
  detailsContainer: {
    flexGrow: 1,
    flexShrink: 1,
  },
  myPlanBenefitsList: {
    alignItems: 'center',
  },
  rightIcon: {
    margin: 16,
    flexShrink: 0,
    tintColor: Colors.vfRed,
  },

  // Card Placeholder
  placeholderTitle: {
    marginBottom: 21,
    marginHorizontal: 16,
    width: '50%',
  },
  placeholderDesc: {
    width: '100%',
  },
  placeholderCta: {
    width: 62,
  },
  placeholderInCoverInfo: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    overflow: 'hidden',
    height: 20,
    paddingHorizontal: 12,
    paddingTop: 1,
    marginLeft: 8,
    width: 100,
  },
})

export default styles
export { itemStyles }
